import ExpertInfoController, {type ExpertsResponse} from "../../preprocess/lib/ExpertInfoController";

function applySpecialtiesResponseToPage(response: ExpertsResponse) {
	for (const [postId, expertInfo] of Object.entries(response)) {
		for (const display of document.querySelectorAll(`.wp-block-plaudit-specialties-summary-display[data-post-id="${postId}"]:not(.set-up)`)) {
			display.classList.toggle('set-up', true);
			display.innerHTML = expertInfo.specialties;
		}
	}
}
function updateAllSpecialtySummaries() {
	return ExpertInfoController.callWithExpertData(applySpecialtiesResponseToPage);
}
document.addEventListener('DOMContentLoaded', () => {
	updateAllSpecialtySummaries().then(() => {
		new MutationObserver(() => updateAllSpecialtySummaries())
			.observe(document, {childList: true, subtree: true});
	});
});
